export default {
  USER: "user",
  ACTION_REGISTRY: "action_registry",
  TOKEN: "token",
  SIDEBAR_INDEX:"sidebar_index",
  TEAMS:"teams",
  CHALLENGE:"challenge",
  AUTH:"auth",
};
